import { AppColors } from '@cmbg-traky-web/design-system';
import { CSSProperties } from 'react';

type Styles = {
  main__header: CSSProperties;
  main__headerBox: CSSProperties;
  backButton: CSSProperties;
  backButton__icon: CSSProperties;
};

const styles: Styles = {
  main__header: {
    display: 'flex',
    backgroundColor: AppColors.VA.NEUTRALS.WHITE,
    borderBottom: `1px solid ${AppColors.VA.NEUTRALS._20_}`
  },
  main__headerBox: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'flex-start',
    gap: '8px',
    width: '100%',
    maxWidth: '1320px',
    margin: '0 auto',
    padding: '14px 16px',
    color: AppColors.VA.PRIMARY._50_,
    height: '52px'
  },
  backButton: {
    background: 'none',
    border: 'none',
    padding: '0.5rem',
    marginRight: '0.75rem',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: 'inherit'
  },
  backButton__icon: {
    fontSize: '1.2rem'
  }
};

export default styles;
